import { CarrotTheme } from '..';
import { FontFaceDescription } from './util';

export const PublicoTextFonts = (theme: CarrotTheme): FontFaceDescription[] => [
    {
        fontFamily: 'Publico Text',
        src: `url('/fonts/PublicoText-Roman-Web.eot'),
            url('/fonts/PublicoText-Roman-Web.eot?#iefix') format('embedded-opentype'),
            url('/fonts/PublicoText-Roman-Web.woff2') format('woff2'),
            url('/fonts/PublicoText-Roman-Web.woff') format('woff')`,
        fontWeight: theme.fontWeights.normal,
        fontStyle: 'normal',
        fontStretch: 'normal',
    },

    {
        fontFamily: 'Publico Text',
        src: `url('/fonts/PublicoText-Italic-Web.eot'), 
            url('/fonts/PublicoText-Italic-Web.eot?#iefix') format('embedded-opentype'),
            url('/fonts/PublicoText-Italic-Web.woff2') format('woff2'),
            url('/fonts/PublicoText-Italic-Web.woff') format('woff')`,
        fontWeight: theme.fontWeights.normal,
        fontStyle: 'italic',
        fontStretch: 'normal',
    },

    {
        fontFamily: 'Publico Text',
        src: `url('/fonts/PublicoText-Semibold-Web.eot'),
            url('/fonts/PublicoText-Semibold-Web.eot?#iefix') format('embedded-opentype'),
            url('/fonts/PublicoText-Semibold-Web.woff2') format('woff2'),
            url('/fonts/PublicoText-Semibold-Web.woff') format('woff')`,
        fontWeight: theme.fontWeights.bold,
        fontStyle: 'normal',
        fontStretch: 'normal',
    },

    {
        fontFamily: 'Publico Text',
        src: `url('/fonts/PublicoText-SemiboldItalic-Web.eot'),
            url('/fonts/PublicoText-SemiboldItalic-Web.eot?#iefix') format('embedded-opentype'),
            url('/fonts/PublicoText-SemiboldItalic-Web.woff2') format('woff2'),
            url('/fonts/PublicoText-SemiboldItalic-Web.woff') format('woff')`,
        fontWeight: theme.fontWeights.bold,
        fontStyle: 'italic',
        fontStretch: 'normal',
    },

    {
        fontFamily: 'Publico Text',
        src: `url('/fonts/PublicoText-Bold-Web.eot'),
            url('/fonts/PublicoText-Bold-Web.eot?#iefix') format('embedded-opentype'),
            url('/fonts/PublicoText-Bold-Web.woff2') format('woff2'),
            url('/fonts/PublicoText-Bold-Web.woff') format('woff')`,
        fontWeight: theme.fontWeights.bolder,
        fontStyle: 'normal',
        fontStretch: 'normal',
    },
    {
        fontFamily: 'Publico Text',
        src: `url('/fonts/PublicoText-BoldItalic-Web.eot'),
            url('/fonts/PublicoText-BoldItalic-Web.eot?#iefix') format('embedded-opentype'),
            url('/fonts/PublicoText-BoldItalic-Web.woff2') format('woff2'),
            url('/fonts/PublicoText-BoldItalic-Web.woff') format('woff')`,
        fontWeight: theme.fontWeights.bolder,
        fontStyle: 'italic',
        fontStretch: 'normal',
    },
];
